<template>
  <div class="main">
    <b-row>
      <b-col cols="12" md="6" sm="12"></b-col>
      <b-col class="text-right" cols="12" md="6" sm="12">
        <p class="m-0">
          วันที่ทำการสมัคร :
          {{ form.userProfile.createdTime | moment($formatDateTime) }}
        </p>
      </b-col>
      <b-col cols="12" md="6" sm="12">
        <InputText
          v-model="form.userProfile.firstname"
          textFloat="ชื่อ"
          isRequired
          class="mr-1"
          placeholder="ชื่อ"
          type="text"
          @onKeyup="submitFormOnInput"
          :isValidate="$v.form.userProfile.firstname.$error"
          :v="$v.form.userProfile.firstname"
        />
      </b-col>
      <b-col cols="12" md="6" sm="12">
        <InputText
          v-model="form.userProfile.lastname"
          textFloat="นามสกุล"
          isRequired
          class="mr-1"
          placeholder="นามสกุล"
          type="text"
          @onKeyup="submitFormOnInput"
          :isValidate="$v.form.userProfile.lastname.$error"
          :v="$v.form.userProfile.lastname"
        />
      </b-col>
      <b-col cols="12" md="6" sm="12">
        <InputText
          v-model="form.userProfile.employeeId"
          textFloat="รหัสพนักงาน"
          class="mr-1"
          placeholder="รหัสพนักงาน"
          type="text"
          @onKeyup="submitFormOnInput"
        />
      </b-col>
      <b-col cols="12" md="6" sm="12">
        <InputText
          v-model="form.userProfile.email"
          textFloat="อีเมล"
          isRequired
          class="mr-1"
          placeholder="อีเมล"
          type="text"
          @onKeyup="submitFormOnInput"
          :isValidate="$v.form.userProfile.email.$error"
          :v="$v.form.userProfile.email"
        />
      </b-col>

      <!-- edit data -->

      <b-col cols="12" md="6" sm="12" v-if="!edit">
        <InputText
          v-model="form.userProfile.password"
          textFloat="รหัสผ่าน"
          isRequired
          class="mr-1"
          placeholder="รหัสผ่าน"
          type="password"
          name="password"
          @onKeyup="submitFormOnInput"
          @onSpace="eventSpace"
          detail="(รหัสผ่านจำเป็นจะต้องมีตัวเลขรวมกันอย่างน้อย 6 ตัว เพื่อความปลอดภัย)"
          :isValidate="$v.form.userProfile.password.$error"
          :v="$v.form.userProfile.password"
        />
      </b-col>
      <b-col cols="12" md="6" sm="12" v-if="!edit">
        <InputText
          v-model="form.userProfile.confirmPassword"
          textFloat="ยืนยันรหัสผ่าน"
          isRequired
          class="mr-1"
          placeholder="ยืนยันรหัสผ่าน"
          type="password"
          name="confirmPassword"
          @onKeyup="submitFormOnInput"
          @onSpace="eventSpace"
          detail="(รหัสผ่านจำเป็นจะต้องมีตัวเลขรวมกันอย่างน้อย 6 ตัว เพื่อความปลอดภัย)"
          :isValidate="$v.form.userProfile.confirmPassword.$error"
          :v="$v.form.userProfile.confirmPassword"
        />
      </b-col>

      <b-col cols="12" v-if="edit">
        <b-button class="btn-editpassword" @click="openModaleditPassword"
          >ตั้งค่ารหัสผ่านใหม่</b-button
        >
      </b-col>

      <b-col cols="12" md="6" sm="12">
        <p class="mb-1 label-input">
          สถานะการใช้งาน
        </p>
        <b-form-checkbox
          v-model="form.userProfile.enabled"
          name="check-button-status"
          size="lg"
          switch
        >
          <span class="ml-2 text-status">
            {{ form.userProfile.enabled ? "ใช้งาน" : "ไม่ใช้งาน" }}
          </span>
        </b-form-checkbox>
      </b-col>
    </b-row>
    <div class="footer">
      <b-button class="btn-cancel" @click="backStep">ย้อนกลับ</b-button>
      <b-button class="btn-save" @click="isCheck">บันทึก</b-button>
    </div>
    <ModalEditPassword @resetPassword="resetPassword" />
  </div>
</template>

<script>
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import ModalEditPassword from "../modal/ModalEditPassword.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    InputText,
    ModalEditPassword,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        roleId: [5],
        userProfile: {
          brandId: 0,
          confirmPassword: null,
          createdTime: "",
          email: "",
          employeeId: "",
          enabled: true,
          firstname: "",
          isVerified: false,
          lastname: "",
          password: null,
          telephone: null,
          employeeId: null,
        },
      },

      cloneData: null,

      //   state toggle
      changePassword: false,

      //  state modal
      dataModal: {
        textModal: "",
        unCheck: false,
      },
    };
  },
  validations() {
    let form = {};

    if (this.changePassword || this.edit) {
      form = {
        userProfile: {
          firstname: { required },
          lastname: { required },
          email: { required, email },
          enabled: { required },
        },
      };
    } else {
      form = {
        userProfile: {
          firstname: { required },
          lastname: { required },
          email: { required, email },
          password: { required, minLength: minLength(6) },
          confirmPassword: {
            required,
            minLength: minLength(6),
            sameAsPassword: sameAs("password"),
          },
          enabled: { required },
        },
      };
    }

    return { form };
  },

  computed: {
    ...mapGetters(["getUserDetail"]),
  },

  mounted() {
    this.getToday();
    this.isCheckEdit();
  },
  methods: {
    async isCheck() {
      this.$v.form.$touch();

      if (this.$v.form.$error) {
        return;
      }

      this.form.userProfile.createdTime = this.$moment(
        this.form.userProfile.createdTime
      ).format();

      const isValidateEmail = await this.axios.get(
        `${this.$baseUrl}/account/IsExistUserName?username=${this.form.userProfile.email}`
      );

      if (isValidateEmail.result == 0 && !this.cloneData) {
        this.dataModal = {
          textModal: "อัเมลนี้ไม่สามารถใช้งานได้",
          unCheck: true,
        };
        this.$emit("openModalText", this.dataModal);

        return;
      }

      this.axios
        .post(`${this.$baseUrl}/account/Save`, this.form)
        .then((result) => {
          if (result.result == 1) {
            this.conditionChangePassword();
          } else {
            this.dataModal = {
              textModal: "อีเมลนี้ถูกใช้งานแล้ว",
              unCheck: true,
            };
            this.$emit("openModalText", this.dataModal);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    conditionChangePassword() {
      // ถ้ามันเป็นการแก้ไข
      if (this.cloneData) {
        if (this.cloneData.email == this.getUserDetail().user.email) {
          var timestamp = new Date().getTime();

          this.$cookies.set("tnl-timestamp", timestamp);
          this.$cookies.remove("tnl-username");
          this.$cookies.remove("tnl-session-token");
          this.$cookies.remove("user-id");

          window.location.href = "/";
        } else {
          this.dataModal = {
            textModal: "แก้ไขสำเร็จ",
            unCheck: false,
          };
          this.$emit("openModalText", this.dataModal);

          this.backStep();
        }
      } else {
        this.dataModal = {
          textModal: "สร้างสำเร็จ",
          unCheck: false,
        };
        this.$emit("openModalText", this.dataModal);

        this.backStep();
      }
    },
    resetPassword(objPassword) {
      this.form = {
        roleId: [5],
        userProfile: {
          ...this.form.userProfile,
          ...objPassword,
        },
      };

      this.changePassword = true;

      this.isCheck();
    },
    eventSpace(event) {
      event.preventDefault();
    },
    getToday() {
      this.form.userProfile.createdTime = new Date();
    },
    openModaleditPassword() {
      this.$bvModal.show("modal-editpassword");
    },
    isCheckEdit() {
      if (this.edit) {
        // clone data for check condition this user

        this.cloneData = { ...this.dataEdit };

        this.form = {
          roleId: [5],
          userProfile: {
            ...this.form.userProfile,
            ...this.dataEdit,
          },
        };
      }
    },
    backStep() {
      this.$emit("backStep");
    },
    submitFormOnInput: function(e) {
      if (e.keyCode === 13) {
        this.checkForm();
      }
    },
  },
};
</script>

<style scoped>
.main {
  position: relative;
  width: 100%;
}
.btn-cancel {
  background: white;
  min-width: 100px;
}
.btn-cancel:hover {
  color: grey !important;
}
.btn-save {
  background: #b41bb4;
  color: white !important;
  border: none;
  min-width: 100px;
}
.btn-editpassword {
  background: #b41bb4;
  color: white !important;
  border: none;
  min-width: 150px;
  margin-bottom: 10px;
}
.label-input {
  font-weight: 700;
  color: #404040;
}
.text-status {
  font-size: 16px;
}
.text-error {
  color: red;
}
.footer {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
